<template>
  <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger fw-bold">＋</span>
</template>

<script setup>
// was the `Special` object at the top of OrderBadge.js
defineOptions({ name: "OrderBadgeSpecial" })
</script>
